import { useGetApprovalItemParticipationsQuery } from 'features/comments/approvalApi';
import HelperFunctions from 'pages/global/HelperFunctions';

/**
 * @param {string} uri
 *
 * @returns {{items: import('models/approval.models').ApprovalParticipation[]}}
 */
export function useGetApprovalItemParticipations(uri) {
    return useGetApprovalItemParticipationsQuery(uri, {
        selectFromResult: (result) => HelperFunctions.queryResult(result),
    });
}
